import React from "react";

import { showErrorToast } from "@shared/toasts/Toasts";

import { getApiKeys } from "../api";

export function useAccountApiKeys() {
    const [apiKeys, setApiKeys] = React.useState<string | undefined>();
    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {
        const loadApiKeys = async () => {
            try {
                const apiKeysData = await getApiKeys();
                setApiKeys(apiKeysData);
            } catch (err) {
                const error = err as Error;
                showErrorToast(error.message);
            } finally {
                setIsLoading(false);
            }
        };
        void loadApiKeys();
    }, []);

    return {
        apiKeys,
        setApiKeys,
        isLoading,
    };
}
